// utils/auth.js

import apiClient from "./apiClient";

const TOKEN_KEY = 'feedcms_token';
const USER_KEY = 'feedcms_user';

export const authStorage = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (t) => localStorage.setItem(TOKEN_KEY, t),
  getUser: () => { try { return JSON.parse(localStorage.getItem(USER_KEY)); } catch { return null; } },
  setUser: (u) => localStorage.setItem(USER_KEY, JSON.stringify(u)),
  clear: () => { localStorage.removeItem(TOKEN_KEY); localStorage.removeItem(USER_KEY); },
};


export async function loginApi({ username, password }) {
  const res = await apiClient.post('/auth-service/auth/login', {
    user: username,
    credentials: password,
  });
  return res.data;
}

export async function validateTokenApi() {
  const res = await apiClient.get('/auth-service/validate/user');
  return res.data;
}

export async function logoutApi() {
  try {
    await apiClient.post('/auth-service/auth/logout');
  } finally {
    authStorage.clear();
  }
}